import Icon from "../Icon";
import { diasLaborablesEntre } from "../timeline/timelineScale";

// Las fechas de los nodos de Inicio y Fin: DATO, no campo.
//
// Antes los dos tenian sus dos DatePicker, igual que un paso de trabajo, y era
// una tonteria de tres capas. Un delimitador no dura, asi que "fecha de fin del
// nodo Inicio" no significa nada; peor, el proyecto YA es el dueño de esas dos
// fechas —start_date y end_date, que se editan en el formulario del proyecto—,
// asi que eran dos sitios para decir lo mismo que podian discrepar sin que
// nadie supiera cual manda. Aqui se enseña la del proyecto y se dice donde se
// cambia.
//
// Y el nodo Fin responde ademas la pregunta que de verdad se le hace: no cuando
// dijimos que acabaria, sino cuando va a acabar.

const MESES = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
export const fmtDia = iso => {
  if (!iso) return null;
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return `${Number(d)} ${MESES[Number(m) - 1]} ${y}`;
};

const Fila = ({ rotulo, children }) => (
  <div className="cw-field" style={{ gap: 4 }}>
    <label>{rotulo}</label>
    <div style={{ fontSize: 12.5, color: "var(--text)", fontWeight: 600 }}>{children}</div>
  </div>
);

const Aparte = ({ children, color = "var(--text3)" }) => (
  <div style={{ fontSize: 11, color, marginTop: 3, fontWeight: 400, lineHeight: 1.5 }}>
    {children}
  </div>
);

export default function FechasDeControl({ kind, proyecto, prevision, festivos = {} }) {
  const sinFecha = (
    <span style={{ color: "var(--text3)", fontWeight: 400 }}>
      Sin fecha · se pone en el proyecto
    </span>
  );

  if (kind === "inicio") {
    return (
      <Fila rotulo="Empieza">
        {fmtDia(proyecto?.start_date) || sinFecha}
        <Aparte>Es la fecha de inicio del proyecto. Se cambia al editarlo.</Aparte>
      </Fila>
    );
  }

  const comprometida = proyecto?.end_date || null;
  const p = prevision || {};
  // Cuanto se desvia lo previsto de lo comprometido, en dias LABORABLES: decir
  // "+11 dias" contando dos fines de semana daria un susto que no toca.
  // diasLaborablesEntre cuenta los dos extremos, asi que acabar el mismo dia da
  // 1: se descuenta con el signo puesto, igual que en desvioPlazo.
  const bruto = comprometida && p.fecha
    ? diasLaborablesEntre(comprometida, p.fecha, festivos) : null;
  const desvio = bruto === null ? null : (bruto > 0 ? bruto - 1 : bruto + 1);
  const tarde = desvio !== null && desvio > 0;

  return (
    <Fila rotulo="Acaba">
      {fmtDia(comprometida) || sinFecha}
      {comprometida && (
        <span style={{ fontWeight: 400, color: "var(--text3)", fontSize: 11 }}> · comprometido</span>
      )}

      {/* La prevision solo se enseña cuando dice algo: repetir la fecha
          comprometida en una segunda linea es ruido. */}
      {p.fecha && (!comprometida || p.fecha !== comprometida) && (
        <Aparte color={tarde ? "var(--red-text)" : "var(--text2)"}>
          <Icon name={tarde ? "exclamation-triangle" : "calendar-check"} size={11}
            color={tarde ? "var(--red-text)" : "var(--text3)"} />
          {" "}Previsto {fmtDia(p.fecha)}
          {desvio !== null && desvio !== 0 && (
            <strong>{" "}({desvio > 0 ? "+" : "−"}{Math.abs(desvio)} {Math.abs(desvio) === 1 ? "dia laborable" : "dias laborables"})</strong>
          )}
          {p.determina && <span> · lo marca «{p.determina.title}»</span>}
          {/* Un paso sin fechas ni estimacion entra en la cuenta como un dia,
              que es un numero puesto a dedo. Si hay varios, la prevision no se
              puede leer como un dato firme y hay que decirlo. */}
          {p.sinEstimar > 0 && (
            <span style={{ color: "var(--text3)" }}>
              {" "}· {p.sinEstimar} {p.sinEstimar === 1 ? "paso cuenta" : "pasos cuentan"} como un dia
              por no tener fechas ni estimacion
            </span>
          )}
        </Aparte>
      )}

      {/* Y cuando no se puede prever se dice por que, en vez de callarse y
          dejar creer que la fecha comprometida esta confirmada. */}
      {!p.fecha && p.motivo === "ciclo" && (
        <Aparte>El flujo tiene un bucle, asi que no hay orden en que recorrerlo: no se puede prever.</Aparte>
      )}
      {!p.fecha && p.motivo === "sin-datos" && (
        <Aparte>Sin fechas ni estimaciones en los pasos no hay con que preverlo.</Aparte>
      )}
    </Fila>
  );
}

// La misma informacion en una linea, para la fila cerrada de la lista. Sin
// abrir el paso hay sitio para una fecha y, si el proyecto se va a pasar, para
// el aviso: que es exactamente lo que uno quiere ver de un vistazo.
export function FechaDelProyecto({ kind, proyecto, prevision }) {
  if (kind === "inicio") {
    return proyecto?.start_date
      ? <span>· empieza {fmtDia(proyecto.start_date)}</span>
      : <span>· sin fecha de inicio</span>;
  }
  const fin = proyecto?.end_date || null;
  const prev = prevision?.fecha || null;
  const tarde = fin && prev && prev > fin;
  return (<>
    {fin ? <span>· acaba {fmtDia(fin)}</span> : <span>· sin fecha de fin</span>}
    {prev && prev !== fin && (
      <span style={{ color: tarde ? "var(--red-text)" : undefined, fontWeight: tarde ? 700 : 400 }}>
        · previsto {fmtDia(prev)}
      </span>
    )}
  </>);
}
